export function Spinner({style = {minHeight: 44}}) {
  return (
    <p className={'row center'} style={style}>
      <span className={'spinner'}></span>
    </p>
  )
}
